(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire0d69"];
var parcelRegister = parcelRequire.register;
parcelRegister("jakXm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df3f350758d7d939$export$2e2bcd8739ae039; });
var $df3f350758d7d939$var$clipboardCopy = function() {
    var copyBtns = document.querySelectorAll(".js-copy-url");
    if (copyBtns) Array.from(copyBtns).forEach(function(btn) {
        btn.addEventListener("click", function() {
            var currentUrl = window.location.href;
            var prevText = btn.innerHTML;
            navigator.clipboard.writeText(currentUrl).then(function() {
                btn.innerHTML = "Copied";
                btn.style.pointerEvents = "none";
                setTimeout(function() {
                    btn.style.pointerEvents = "";
                    btn.innerHTML = prevText;
                }, 3000);
            });
        });
    });
};
var $df3f350758d7d939$export$2e2bcd8739ae039 = $df3f350758d7d939$var$clipboardCopy;

});

})();
//# sourceMappingURL=clipboard-copy.fc95fb6c.js.map
